module.exports = __webpack_public_path__ + "img/scan.b5d41f95.svg";